import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  getRestaurant,
  updateRestaurant,
} from "../../store/slice/foodBeverageSlice";
import { SidebarComponent } from "../../helpers/commonFunction";

const DeleteRestaurant = ({
  show,
  restaurantDetail,
  handleClose,
  setDeleteModal,
  setDeleteModalId,
}) => {
  const dispatch = useDispatch();
  const showHideClassName = show && "user_detail_modal_show";
  const { t } = useTranslation("common");
  const sideHeading = localStorage.getItem("sidebar_component");

  const deleteRestaurantHandler = () => {
    const data = {
      delete_status: "1",
    };
    dispatch(
      updateRestaurant({
        data,
        id: restaurantDetail,
        cb: (err, res) => {
          if (err) {
            console.log("err", err);
          } else {
            dispatch(getRestaurant({}));
            setDeleteModal(false);
            setDeleteModalId("");
          }
        },
        toast: t("toast.delete_restaurant"),
      })
    );
  };

  return (
    <>
      <div
        className={`user_detail_modal_bg  ${showHideClassName}`}
        onClick={handleClose}
      ></div>
      <section
        className={`user_detail_modal_main delete_feedback_modal ${showHideClassName}`}
      >
        <div className="inquiry_complaint_detail_section">
          <h2 className="announcement_page-view-modal">
            Delete {SidebarComponent()}
            {/* {sideHeading} */}
          </h2>
          <h4 className="announcement_page-view-modal delete_feedback_subheading">
            {t("modal.delete.deleteRestaurantDesc")}
          </h4>
          <div className="delete_feedback_btn-container">
            <button
              type="button"
              onClick={handleClose}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn secondary_btn"
            >
              {t("common.close")}
            </button>
            <button
              type="button"
              onClick={deleteRestaurantHandler}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn ml-20"
            >
              {t("common.delete")}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeleteRestaurant;
